import { Settings as SettingsIcon, Shield, Bell, Info } from 'lucide-react';

export default function Settings() {
  return (
    <div>
      {/* 頁首 */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-brand-cocoa font-heading">
          設定
        </h2>
        <p className="mt-1 text-sm text-gray-500">
          系統設定與偏好
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* 帳號 */}
        <div className="bg-white rounded-xl border border-brand-bake p-5 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-brand-cream">
              <Shield className="h-5 w-5 text-brand-gold" />
            </div>
            <h3 className="text-base font-semibold text-brand-cocoa">
              管理員帳號
            </h3>
          </div>
          <p className="text-sm text-gray-500 mb-4">
            管理員帳號由系統管理員在資料庫中設定。如需新增或修改管理員，請聯繫系統管理員。
          </p>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-brand-cream rounded-lg">
              <span className="text-sm text-gray-600">目前登入身份</span>
              <span className="text-sm font-medium text-brand-caramel">管理員</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-brand-cream rounded-lg">
              <span className="text-sm text-gray-600">Session 時效</span>
              <span className="text-sm font-medium text-brand-caramel">30 分鐘</span>
            </div>
          </div>
        </div>

        {/* 通知 */}
        <div className="bg-white rounded-xl border border-brand-bake p-5 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-brand-cream">
              <Bell className="h-5 w-5 text-brand-gold" />
            </div>
            <h3 className="text-base font-semibold text-brand-cocoa">
              通知設定
            </h3>
          </div>
          <p className="text-sm text-gray-500 mb-4">
            訂單狀態變更通知（LINE / Email）由前台系統自動觸發。管理員操作會在 order_events 留下記錄。
          </p>
          <div className="p-3 bg-blue-50 rounded-lg text-sm text-blue-700">
            狀態變更會記錄操作員與時間戳記，確保營運可追溯。
          </div>
        </div>

        {/* 系統資訊 */}
        <div className="bg-white rounded-xl border border-brand-bake p-5 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-brand-cream">
              <Info className="h-5 w-5 text-brand-gold" />
            </div>
            <h3 className="text-base font-semibold text-brand-cocoa">
              系統資訊
            </h3>
          </div>
          <div className="space-y-3 text-sm">
            <div className="flex justify-between py-2 border-b border-brand-bake/30">
              <span className="text-gray-500">平台</span>
              <span className="font-medium">Cloudflare Workers + D1</span>
            </div>
            <div className="flex justify-between py-2 border-b border-brand-bake/30">
              <span className="text-gray-500">API 版本</span>
              <span className="font-medium">v1.0</span>
            </div>
            <div className="flex justify-between py-2 border-b border-brand-bake/30">
              <span className="text-gray-500">管理面板</span>
              <span className="font-medium">React 19 + Vite + Tailwind CSS</span>
            </div>
            <div className="flex justify-between py-2">
              <span className="text-gray-500">品牌</span>
              <span className="font-medium text-brand-caramel">怡味屋 Yiweiwu</span>
            </div>
          </div>
        </div>

        {/* 系統狀態 */}
        <div className="bg-white rounded-xl border border-brand-bake p-5 shadow-sm">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-brand-cream">
              <SettingsIcon className="h-5 w-5 text-brand-gold" />
            </div>
            <h3 className="text-base font-semibold text-brand-cocoa">
              系統狀態
            </h3>
          </div>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <span className="text-sm text-gray-600">API 服務</span>
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-green-500" />
                <span className="text-sm font-medium text-status-success">正常運作</span>
              </div>
            </div>
            <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
              <span className="text-sm text-gray-600">資料庫連線</span>
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-green-500" />
                <span className="text-sm font-medium text-status-success">正常連線</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
